import request from '@/utils/request'
// 后台接口
export const api = {
  // get
  get(url, params = {}) {
    return request({
      method: 'get',
      module: 'api.php/',
      url,
      params,
    })
  },
  // post
  post(url, data = {}) {
    return request({
      method: 'post',
      module: 'api.php/',
      url,
      data,
    })
  },
}
